<template>
    <v-card flat color="transparent">
                <v-card-title class="justify-center">
                    <p class="headline">
                        Access Account
                    </p>
                </v-card-title>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" md="3">
                             <v-form @submit.prevent="submit">
                                <v-text-field
                                        ref="username"
                                        v-model.trim="$v.username.$model"
                                        label="Username"
                                        outlined
                                        :error-messages="usernameError"
                                        error-count=2
                                        required>
                                </v-text-field>
                                <v-text-field
                                        ref="password"
                                        v-model.trim="$v.password.$model"
                                        type="password"
                                        label="Password"
                                        outlined
                                        :error-messages="passwordError"
                                        required>
                                </v-text-field>

                                <v-alert
                                        v-model="alert.show"
                                        dismissible
                                        outlined
                                        transition="scale-transition"
                                        :type= "alert.type">
                                    {{alert.msg}}
                                </v-alert>

                                <v-row align="center"  justify="center" dense>
                                    <v-col cols="6" md="6" justify-self="center">
                                        <v-checkbox
                                                    v-model="rememberMe"
                                                    label="Remember me"
                                                    value="Remember me"
                                        >

                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-btn text
                                               color="blue"
                                               block
                                               @click="forgotPassword"
                                               >
                                            <u style=" text-transform: none;">Forgot your password?</u>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <v-row align="center" justify="center">
                                    <v-col cols="12" md="6">
                                        <v-btn  color="primary"
                                                drak
                                                block
                                                large
                                                type="submit"
                                                :loading="showSubmit"
                                                :disabled="showSubmit"
                                                @click.stop="submit">
                                            LOGIN
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-btn  color="balck"
                                                dark
                                                block
                                                large
                                                @click="SingUp">
                                            SIGN UP
                                        </v-btn>
                                    </v-col>
                                </v-row>
                             </v-form>
                        </v-col>
                    </v-row>
                </v-card-text>
    </v-card>
</template>

<script>
    import {Auth} from 'aws-amplify';
    import {AmplifyEventBus} from 'aws-amplify-vue';
    import {required} from 'vuelidate/lib/validators'

    export default {
        name: "LogIn",
        data(){
            return{
                username:'',
                password:'',
                alert: {
                    show: false,
                    type:'success',
                    msg: 'Success'
                },
                showSubmit: false,
                rememberMe: false,
            }
        },
        validations:{
            username:{
                required
            },
            password: {
                required
            }
        },
        computed:{
            usernameError(){
                const errors = [];
                if (!this.$v.$dirty) {
                    return errors
                }

                !this.$v.username.required && errors.push('Username is required.')
                return errors
            },
            passwordError(){
                const errors = [];
                if (!this.$v.$dirty) {
                    return errors
                }
                !this.$v.password.required && errors.push('Password is required.')
                return errors
            }
        },
        methods:{
            async logIn(){
                try {
                    this.showSubmit = true;
                    await Auth.signIn(this.username.toLowerCase(), this.password);
                    AmplifyEventBus.$emit('authState', 'signedIn');
                    this.$router.push(this.$route.query.redirect || '/');
                }
                catch (e) {
                    this.showSubmit = false;
                    this.$emit('submit', false)
                    this.setAlert('error', e.message)
                }
            },
            submit(){
                this.$v.$touch();
                if(this.$v.$anyError){
                    return;
                }

                this.logIn();
            },
            setAlert(type, msg){
                this.alert.show = true;
                this.alert.type = type;
                this.alert.msg = msg;
            },
            forgotPassword(){
                AmplifyEventBus.$emit('authState', 'forgotPassword');
            },
            SingUp(){
                AmplifyEventBus.$emit('authState', 'signUp');
            }
        }
    }
</script>

<style scoped>
    label{
    margin: 0px !important;
}
</style>